<script setup>
import Toast from "primevue/toast";
import { nextTick, onMounted, ref } from "vue";
import { RouterView } from "vue-router";
import { loadFeatureFlags } from "@/composables/featureFlags";
import { translate } from "@/composables/translate";

const appKey = ref(0);
const mainContent = ref(null);
function rebuildApplication() {
  appKey.value += 1;
}

async function skipToContent() {
  await nextTick();
  mainContent.value?.focus();
}

onMounted(() => {
  loadFeatureFlags();
});
</script>

<template>
  <div>
    <a href="#main-content" class="skip-link" @click="skipToContent">
      {{ translate('skip to main content', 'ucfirst') }}
    </a>
    <Toast position="top-right" style="z-index: 10000" />
    <div id="main-content" ref="mainContent" tabindex="-1">
      <RouterView @rebuildApplication="rebuildApplication" :appKey="appKey"> </RouterView>
    </div>
  </div>
</template>
